(function () {
  function initElegantParallax() {
    const parallaxElements = document.querySelectorAll('[data-enable-parallax="true"]');
    const textParallaxElements = document.querySelectorAll('[data-text-parallax="true"]');

    if (parallaxElements.length === 0 && textParallaxElements.length === 0) return;

    let currentScroll = window.scrollY;
    let targetScroll = window.scrollY;
    let ticking = false;

    const activeParallax = new Set();
    const activeTextParallax = new Set();

    // Smooth lerp helper
    function lerp(start, end, ease) {
      return start + (end - start) * ease;
    }

    // IntersectionObserver (track visible elements only)
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          const el = entry.target;

          if (entry.isIntersecting) {
            if (el.hasAttribute("data-enable-parallax")) activeParallax.add(el);
            if (el.hasAttribute("data-text-parallax")) activeTextParallax.add(el);
          } else {
            if (el.hasAttribute("data-enable-parallax")) {
              activeParallax.delete(el);

              const image = el.querySelector("img");
              if (image) {
                image.style.transform = "";
                image.style.opacity = "";
              }
            }

            if (el.hasAttribute("data-text-parallax")) {
              activeTextParallax.delete(el);

              const baseTransform = el.getAttribute("data-base-transform") || "";
              el.style.transform = baseTransform;
              el.style.opacity = "";
            }
          }
        });
      },
      {
        root: null,
        threshold: 0.05
      }
    );

    function storeBaseTransform() {
      textParallaxElements.forEach(el => {
        const computed = window.getComputedStyle(el).transform;
        if (computed && computed !== "none") {
          el.setAttribute("data-base-transform", computed);
        } else {
          el.setAttribute("data-base-transform", "");
        }
      });
    }

    storeBaseTransform();

    // Observe all parallax elements
    parallaxElements.forEach(el => observer.observe(el));
    textParallaxElements.forEach(el => observer.observe(el));

    function update() {
      currentScroll = lerp(currentScroll, targetScroll, 0.08);

      // IMAGE PARALLAX (only visible ones)
      activeParallax.forEach(el => {
        const rect = el.getBoundingClientRect();
        const elementTop = rect.top + window.scrollY;
        const elementHeight = rect.height;
        const windowHeight = window.innerHeight;

        const image = el.querySelector("img");
        if (!image) return;

        const intensity = parseFloat(el.getAttribute("data-intensity")) || 0.3;
        const animationType = el.getAttribute("data-animation-type") || "default";

        const scrollProgress =
          (currentScroll + windowHeight - elementTop) / (windowHeight + elementHeight);

        const clampedProgress = Math.max(0, Math.min(1, scrollProgress));

        const offset = (clampedProgress - 0.5) * 220 * intensity;

        switch (animationType) {
          case "smooth-scale": {
            const scale = 1.08 + (Math.abs(clampedProgress - 0.5) * 0.08 * intensity);
            image.style.transform = `translate3d(0, ${offset}px, 0) scale(${scale})`;
            image.style.opacity = "";
            break;
          }

          case "depth-layers": {
            image.style.transform = `translate3d(0, ${offset * 1.4}px, 0) scale(1.05)`;
            image.style.opacity = "";
            break;
          }

          case "magnetic": {
            const magneticOffset = Math.sin(clampedProgress * Math.PI) * 70 * intensity;
            image.style.transform = `translate3d(${magneticOffset * 0.15}px, ${magneticOffset}px, 0) scale(1.05)`;
            image.style.opacity = "";
            break;
          }

          case "reveal": {
            const opacity = 0.4 + clampedProgress * 0.6;
            image.style.opacity = opacity;
            image.style.transform = `translate3d(0, ${(1 - clampedProgress) * 120 * intensity}px, 0) scale(1.05)`;
            break;
          }

          default: {
            image.style.transform = `translate3d(0, ${offset}px, 0) scale(1.06)`;
            image.style.opacity = "";
          }
        }
      });

      // TEXT PARALLAX (only visible ones)
      activeTextParallax.forEach(el => {
        const rect = el.getBoundingClientRect();
        const elementTop = rect.top + window.scrollY;
        const elementHeight = rect.height;
        const windowHeight = window.innerHeight;

        const speed = parseFloat(el.getAttribute("data-parallax-speed")) || 0.5;

        const scrollProgress =
          (currentScroll + windowHeight - elementTop) / (windowHeight + elementHeight);

        const clampedProgress = Math.max(0, Math.min(1, scrollProgress));

        const textOffset = (clampedProgress - 0.5) * 90 * speed;
        const opacity = 0.7 + clampedProgress * 0.3;

        const baseTransform = el.getAttribute("data-base-transform") || "";
        el.style.transform = `${baseTransform} translate3d(0, ${textOffset}px, 0)`;
        el.style.opacity = opacity;
      });

      ticking = false;
    }

    function requestTick() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener(
      "scroll",
      () => {
        targetScroll = window.scrollY;
        requestTick();
      },
      { passive: true }
    );

    window.addEventListener("resize", () => {
      storeBaseTransform();
      requestTick();
    });

    update();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initElegantParallax);
  } else {
    initElegantParallax();
  }
})();
